/**
 * Dataverse URL utilities for opening records in Dynamics 365
 */

const DATAVERSE_URL = import.meta.env.VITE_DATAVERSE_URL || '';

export type DataverseEntityType = 'contact' | 'account';

/**
 * Generate a URL to open a Dataverse record in Dynamics 365
 * @param entityType - The type of entity ('contact' or 'account')
 * @param recordId - The GUID of the record
 * @returns The full URL to open the record, or null if DATAVERSE_URL is not configured
 */
export function getDataverseRecordUrl(
  entityType: DataverseEntityType,
  recordId: string
): string | null {
  if (!DATAVERSE_URL || !recordId) {
    return null;
  }

  // Remove any curly braces from the GUID if present
  const cleanId = recordId.replace(/[{}]/g, '');

  return `${DATAVERSE_URL}/main.aspx?etn=${entityType}&id=${cleanId}&pagetype=entityrecord`;
}

/**
 * Check if Dataverse integration is configured
 */
export function isDataverseConfigured(): boolean {
  return !!DATAVERSE_URL;
}
